import * as React from 'react';
import { Dispatch } from 'react-redux';
import { StoreState } from '../../reducers';
import { StaticPageIframe } from './styles';
import RoutesUtils from '../../utils/routes';
import UserAgentUtils from '../../utils/userAgent';
import { DownloadManagerState } from '../../containers/DownloadManager/reducer';
import DownloadManagerUtils from '../../utils/downloadManager';
import { DriveListState } from '../../containers/DriveItemList/reducer';
import { DriveItemOrigin, viewDriveItem, getOrFetchDriveItemMeta, PublicationOptions } from '../../containers/DriveItemList/actions';
import { Api } from '../../typings/api';
import { PostMessageTarget, PostMessageAction } from '../../utils/iframeApi/ReaderApi';
import { createNotification } from '../../containers/NotificationBar/actions';
import Page from '../../containers/Page';
import { PageType } from '../../containers/Page/constants';

/*
// navitation can be triggered from the welcome page in the iframe

// Script to put anywhere in the welcomepage template
<script>
	function openLink(link) {
		parent.postMessage({
			target: 'GallApp',
			action: 'goTo',
			params: {
				url:link
			}
		}, '*')
	}
	function openDriveItem(id, page, hideWelcomePage) {
		parent.postMessage({
			target: 'GallApp',
			action: 'openDriveItem',
			params: {
				id:id,
				page:page,
				hideWelcomePage: hideWelcomePage
			}
		}, '*')
	}
</script>

// Exemple for a link that goes to "News" panel
<a href="javascript:openLink('/list/new')">a link </a> <br />

// Exemple for a link that goes to the folder 409327 and open the image 459052 in theater
<a href="javascript:openDriveItem('list/folder/409327/theater/459052')">a link </a> <br />


// Exemple that open image 472931 in the theater
<a href="javascript:openDriveItem(472931)">a link </a> <br />
*/

interface MessageGoto {
	target: PostMessageTarget.GallApp;
	action: PostMessageAction.GoTo;
	params: {
		url: string;
	};
}

interface MessageOpenDriveItem {
	target: PostMessageTarget.GallApp;
	action: PostMessageAction.OpenDriveItem;
	params: {
		id: number;
		page?: number;
		hideWelcomePage?: boolean;
	};
}

export interface StaticPageProps {
	downloadManager: DownloadManagerState;
	driveList: DriveListState;
	iframeUrl: string;
	dispatch: Dispatch<StoreState>;
}

export class StaticPage extends React.Component<StaticPageProps, {}> {

	componentDidMount() {
		window.addEventListener('message', this.handleFrameTasks);
	}

	componentWillUnmount() {
		window.removeEventListener('message', this.handleFrameTasks);
	}

	handleFrameTasks = (e) => {
		if (e.data.target === 'GallApp') {
			if (e.data.action === 'goTo' && e.data.params && e.data.params.url) {
				this.handleMessageGoTo(e.data);
			}
			if (e.data.action === 'openDriveItem' && e.data.params && e.data.params.id) {
				this.handleMessageOpenDriveItem(e.data);
			}
		}
	}

	handleMessageGoTo(messageGoto: MessageGoto) {
		RoutesUtils.historyPush(messageGoto.params.url);
	}

	handleMessageOpenDriveItem(messageOpenDriveItem: MessageOpenDriveItem) {
		const { dispatch, driveList, downloadManager } = this.props;
		const { isMobileApp, isOnline } = UserAgentUtils;
		const isAsync = isMobileApp;

		const driveItemId = messageOpenDriveItem.params.id;
		const publicationOptions: PublicationOptions = {
			page: messageOpenDriveItem.params.page,
			hideWelcomePage: messageOpenDriveItem.params.hideWelcomePage,
		};
		const driveItemMeta = driveList.driveItems[driveItemId];
		const needFetching = !driveItemMeta && isOnline();
		const isDownloaded = DownloadManagerUtils.isItemDownloaded(downloadManager, driveItemId);
		const isAccessible = driveItemMeta && (isOnline() || isDownloaded || driveItemMeta.type === Api.DriveItemType.Directory || driveItemMeta.type === Api.DriveItemType.Image);

		if (needFetching) {
			dispatch(getOrFetchDriveItemMeta(driveItemId, false, isAsync))
				.then((driveItem: Api.DriveItem) => {
					dispatch(viewDriveItem(driveItem, DriveItemOrigin.Menu, publicationOptions));
				});
		} else if (isAccessible) {
			dispatch(viewDriveItem(driveItemMeta, DriveItemOrigin.Menu, publicationOptions));
		} else {
			dispatch(createNotification('info.offline_download_single_asset'));
			return;
		}
	}

	render() {
		return (
			<Page pageType={PageType.StaticPage}>
				<StaticPageIframe src={this.props.iframeUrl} />
			</Page>
		);
	}
}

export default StaticPage;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/StaticPage/index.tsx